'use strict';

class Accordion {
  init() {
    window.addEventListener(
      'load',
      () => {
        this.faqSlide();
      },
      false
    );
  }

  faqSlide() {
    const slideUp = (el, duration = 400) => {
      if (window.getComputedStyle(el).display === 'inline-block') {
        el.style.display = 'block';
      }
      el.style.height = el.offsetHeight + 'px';
      el.offsetHeight;
      el.style.transitionProperty = 'height, margin, padding, opacity';
      el.style.transitionDuration = duration + 'ms';
      el.style.transitionTimingFunction = 'ease';
      el.style.overflow = 'hidden';
      el.style.height = 0;
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
      el.style.marginTop = 0;
      el.style.marginBottom = 0;
      el.style.opacity = 0;
      setTimeout(() => {
        el.style.display = 'none';
        el.style.removeProperty('height');
        el.style.removeProperty('padding-top');
        el.style.removeProperty('padding-bottom');
        el.style.removeProperty('margin-top');
        el.style.removeProperty('margin-bottom');
        el.style.removeProperty('overflow');
        el.style.removeProperty('transition-duration');
        el.style.removeProperty('transition-property');
        el.style.removeProperty('transition-timing-function');
        el.style.removeProperty('opacity');
        el.classList.remove('is-open');
      }, duration);
    };

    const slideDown = (el, duration = 400) => {
      el.classList.add('is-open');
      el.style.removeProperty('display');
      let display = window.getComputedStyle(el).display;
      if (display === 'none') {
        display = 'flex';
      }
      const isInlineBlock = display === 'inline-block';
      el.style.display = isInlineBlock ? 'block' : display;
      let height = el.offsetHeight;
      el.style.overflow = 'hidden';
      el.style.height = 0;
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
      el.style.marginTop = 0;
      el.style.marginBottom = 0;
      el.style.opacity = 0;
      el.offsetHeight;
      el.style.transitionProperty = 'height, margin, padding, opacity';
      el.style.transitionDuration = duration + 'ms';
      el.style.transitionTimingFunction = 'ease';
      el.style.height = height + 'px';
      el.style.opacity = 1;
      el.style.removeProperty('padding-top');
      el.style.removeProperty('padding-bottom');
      el.style.removeProperty('margin-top');
      el.style.removeProperty('margin-bottom');
      el.style.removeProperty('opacity');
      setTimeout(() => {
        el.style.removeProperty('height');
        el.style.removeProperty('overflow');
        el.style.removeProperty('transition-duration');
        el.style.removeProperty('transition-property');
        el.style.removeProperty('transition-timing-function');
        if (isInlineBlock) {
          el.style.removeProperty('display');
        }
      }, duration);
    };

    const slideToggle = (el, duration = 400) => {
      if (window.getComputedStyle(el).display === 'none') {
        return slideDown(el, duration);
      } else {
        return slideUp(el, duration);
      }
    };

    const accordions = document.querySelectorAll('.js-accordion');
    accordions.forEach((accordion) => {
      const accordionTriggers = accordion.querySelectorAll('.js-accordion-trigger');
      accordionTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          trigger.classList.toggle('is-active');
          const content = trigger.querySelector('.faq__a');
          slideToggle(content);
        });
      });
    });
  }
}
const accordion = new Accordion();
accordion.init();